<template>
  <div class="w100 pl10 pt10 pr10 pb10 h100">
    <Sift ref="needSift" :sift-data="siftData" v-if="siftData.length" @change="initPage">
      <el-col class="flex-box al-c" :span="8">
        <el-button class="mb10 ml10" type="primary" @click="initPage">查询</el-button>
        <el-button class="mb10 ml10" type="primary" @click="add">添加</el-button>
      </el-col>
    </Sift>

    <el-table
      class="mt20 table"
      header-row-class-name="table-head"
      row-class-name="cu-p"
      stripe
      :data="list"
    >
      <el-table-column align="center" label="序号" width="50px">
        <template slot-scope="scope">{{ current * size - size + scope.$index + 1 }}</template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="name"
        label="名称"
      ></el-table-column>
      <el-table-column
        align="center"
        prop="createTime"
        label="创建时间"
      ></el-table-column>
      <el-table-column align="center" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="goSearch(scope.row)"
          >预览
          </el-button>
          <el-button
            type="text"
            @click="eidt(scope.row)"
          ><span>编辑</span>
          </el-button>
          <el-button
            type="text"
            @click="deleteSearch(scope.row)"
          ><span style="color: red">删除</span>
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="mt20 flex-box">
      <div class="flex-1"></div>
      <el-pagination
        background
        @current-change="changePage"
        :current-page="current"
        :page-size="size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <Add ref="addDialog" @refresh="initPage"/>

    <el-dialog
      title="提示"
      :visible.sync="deleteDialog"
      width="300px"
    >
      <span>是否删除：{{selectedRow.name}}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteSubmit">确 定</el-button>
        <el-button @click="deleteDialog = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sift from "@/components/sift/Sift";
import Add from '@/components/management/search/Add'
import {sysDatasourceQueryList, sysDatasourceQueryId, sysDatasourceQueryDelete} from '@/api/management/search'

export default {
  name: "search",
  components: {
    Sift,
    Add,
  },
  props: [],
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      siftData: [
        {
          type: "text",
          key: "name",
          label: "名称",
          placeholder: "",
          default: "",
        },
      ],
      current: 1,
      size: 10,
      total: 0,
      list: [],
      deleteDialog: false,
      selectedRow: {}
    };
  },
  computed: {
  },
  created() {
    this.$nextTick(() => {
      this.initPage()
    })
  },
  mounted() {},
  destroyed() {},
  methods: {
    initPage(){
      this.current = 1
      this.getList()
    },
    changePage(page){
      this.current = page;
      this.getList()
    },
    getList(){
      let searchData = this.$refs.needSift.getValue();
      sysDatasourceQueryList({
        current: this.current,
        size: this.size,
        keywords: searchData.name,
      }).then(({data}) => {
        if(data.code == 0){
          this.list = data.data.records
          this.total = data.data.total;
        }else {
          this.$message.error(data.msg)
        }
      })
    },
    add(){
      this.$refs.addDialog.dialogOpen()
    },
    eidt(row){
      this.$refs.addDialog.dialogOpen(row)
    },
    deleteSearch(row){
      this.selectedRow = row;
      this.deleteDialog = true;
    },
    deleteSubmit(){
      sysDatasourceQueryDelete({ids: this.selectedRow.id})
      .then(({data}) => {
        if(data.code == 0){
          this.$message.success('删除成功')
          this.initPage()
        }else {
          this.$message.error(data.msg)
        }
      }).finally(() => {
        this.deleteDialog = false
      })
    },
    goSearch(row){
      let routeData = this.$router.resolve({
        name:'/search',
        query: {
          id: row.id
        }
      });
      window.open(routeData.href);
    },
  },
  watch: {
  },
  filters: {}
};
</script>

<style scoped lang="less">
/deep/.el-table {
    .el-table__body-wrapper {
      max-height: calc(100vh - 300px);
      overflow-y: auto;

    }
  }
</style>
